<template>
  <div>
    <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="operate"
      :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs" loadingMore="true"
      @returnId="returnId" @isPageSmall="isPageSmall" @returnProductId="returnProductId" ref="table"></common-table>
    <div class="dialog">
      <el-dialog title="获取可推广商品" :visible.sync="visible" custom-class="common-dialog" :close-on-click-modal="false"
        @close="resetForm('updateForm')" :width="pageSmall ? '85%' : '30%'">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px" :model="updateForm" ref="updateForm">
            <el-form-item label="广告主:" prop="advertiserId"
              :rules="[{ required: true, message: '广告主不能为空', trigger: 'blur' }]">
              <el-select filterable v-model="updateForm.advertiserId" clearable placeholder="请选择广告主" size="medium"
                class="mr10 mb-10" @change="handleAdvertiserChange">
                <el-option v-for="option in advertiserList" :key="option.id" :label="option.name"
                  :value="option.id.toString()" />
              </el-select>
            </el-form-item>

            <el-form-item label="抖音账号:" prop="douyinId"
              :rules="[{ required: true, message: '请选择抖音账号', trigger: 'blur' }]">
              <el-select filterable v-model="updateForm.douyinId" clearable placeholder="请选择抖音账号" size="medium"
                class="mr10 mb-10" :disabled="!updateForm.advertiserId">
                <el-option v-for="option in currentDouyinList" :key="option.id" :label="option.name"
                  :value="option.id.toString()" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="visible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitBatch('updateForm')">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="手动创建全域推广计划" :visible.sync="creatVisible" custom-class="common-dialog"
        :close-on-click-modal="false" @close="resetForm('creatForm')" :width="pageSmall ? '85%' : '30%'">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px" :model="creatForm" ref="creatForm">
            <el-form-item label="广告主:" prop="advertiserId"
              :rules="[{ required: true, message: '广告主不能为空', trigger: 'blur' }]">
              <el-select filterable v-model="creatForm.advertiserId" clearable placeholder="请选择广告主" size="medium"
                class="mr10 mb-10" @change="handleCreatAdvertiserChange">
                <el-option v-for="option in advertiserList" :key="option.id" :label="option.name"
                  :value="option.id.toString()" />
              </el-select>
            </el-form-item>

            <el-form-item label="抖音账号:" prop="aweMeId"
              :rules="[{ required: true, message: '请选择抖音账号', trigger: 'blur' }]">
              <el-select filterable v-model="creatForm.aweMeId" clearable placeholder="请选择抖音账号" size="medium"
                class="mr10 mb-10" :disabled="!creatForm.advertiserId">
                <el-option v-for="option in currentDouyinList" :key="option.id" :label="option.name"
                  :value="option.id.toString()" />
              </el-select>
            </el-form-item>

            <el-form-item label="ROI" prop="roi" :rules="[{ required: true, message: 'ROI不能为空', trigger: 'blur' }]">
              <el-input v-model="creatForm.roi" placeholder="请输入ROI"></el-input>
            </el-form-item>
            <el-form-item label="预算" prop="budget" :rules="[{ required: true, message: '预算不能为空', trigger: 'blur' }]">
              <el-input v-model="creatForm.budget" placeholder="请输入预算"></el-input>
            </el-form-item>

            <el-form-item label="商品ID" prop="productId"
              :rules="[{ required: true, message: '商品ID不能为空', trigger: 'blur' }]">
              <el-input type="textarea" v-model="creatForm.productId" placeholder="请输入商品ID,以英文逗号隔开" :rows="4"
                resize="none"></el-input>
            </el-form-item>

          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="creatVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitCreatBatch('creatForm')">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="自动创建全域推广计划" :visible.sync="creatTaskVisible" custom-class="common-dialog"
        :close-on-click-modal="false" @close="resetForm('creatTaskForm')" :width="pageSmall ? '85%' : '30%'">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px" :model="creatTaskForm" ref="creatForm">
            <el-form-item label="广告主:" prop="advertiserId"
              :rules="[{ required: true, message: '广告主不能为空', trigger: 'blur' }]">
              <el-select filterable v-model="creatTaskForm.advertiserId" clearable placeholder="请选择广告主" size="medium"
                class="mr10 mb-10" @change="handleCreatTaskChange">
                <el-option v-for="option in advertiserList" :key="option.id" :label="option.name"
                  :value="option.id.toString()" />
              </el-select>
            </el-form-item>

            <el-form-item label="抖音账号:" prop="aweMeId"
              :rules="[{ required: true, message: '请选择抖音账号', trigger: 'blur' }]">
              <el-select filterable v-model="creatTaskForm.aweMeId" clearable placeholder="请选择抖音账号" size="medium"
                class="mr10 mb-10" :disabled="!creatTaskForm.advertiserId">
                <el-option v-for="option in currentDouyinList" :key="option.id" :label="option.name"
                  :value="option.id.toString()" />
              </el-select>
            </el-form-item>

            <!--            <el-form-item label="ROI" prop="roi"
                          :rules="[{ required: true, message: 'ROI不能为空', trigger: 'blur'}]">
              <el-input v-model="creatForm.roi" placeholder="请输入ROI"></el-input>
            </el-form-item>
            <el-form-item label="预算" prop="budget"
                          :rules="[{ required: true, message: '预算不能为空', trigger: 'blur'}]">
              <el-input v-model="creatForm.budget" placeholder="请输入预算"></el-input>
            </el-form-item>-->
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="creatTaskVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitCreatTaskBatch('creatForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: 'LaunchTheProduct',
  components: { CommonTable },
  data() {
    return {
      pageSmall: false,
      selectIds: [],
      selectProductIds: [],
      visible: false,
      advertiserList: [],
      douyinIds: [],
      currentDouyinList: [],
      updateForm: {
        advertiserId: '',
        douyinId: ''
      },

      creatVisible: false,
      creatForm: {
        advertiserId: '',
        aweMeId: '',
        roi: '',
        budget: '',
        productId: ''
      },

      creatTaskVisible: false,
      creatTaskForm: {
        advertiserId: '',
        aweMeId: '',
        roi: '',
        budget: '',
        productId: ''
      },
      searchs: [/*{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },*/ {
          name: 'advertiserId',
          placeholder: '广告主',
          type: 'select',
          select2: true,
        selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
          valueKey: 'advertiserId',
          selectData: [],
        }/*, {
        name: 'aweMeId',
        placeholder: '抖音号',
        type: 'input'
      }*/, {
          name: 'aweMeId',
          placeholder: '抖音名称',
          type: 'select',
          select3: true,
          selectUrl: '/oceanEngineAdvertiser/getAllInfoAndDouYin',
          selectData: [],
        }/*, {
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      }, {
        name: 'productId',
        placeholder: '商品ID',
        type: 'input'
      }, {
        name: 'productName',
        placeholder: '商品名称',
        type: 'input'
      }, {
        name: 'isRelease',
        placeholder: '是否可投放',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '可投放',
        }, {
          key: 0,
          value: '不能投放',
        }]
      }, {
        name: 'isCreated',
        placeholder: '是否创建',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '创建完成',
        },{
          key: 2,
          value: '创建中',
        }, {
          key: 0,
          value: '未创建',
        }]
      }*/],
      permission: {
        add: 'launchTheProduct:add',
        update: 'launchTheProduct:update',
        delete: 'launchTheProduct:delete',
        deleteBatch: 'launchTheProduct:deleteBatch'
      },
      url: {
        get: '/launchTheProduct/listByCondition',
        add: '/launchTheProduct/add',
        update: '/launchTheProduct/update',
        delete: '/launchTheProduct/delete',
        delete_batch: '/launchTheProduct/deleteBatch',
        status: '/launchTheProduct/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: false,
        width: '100',
      }/*, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
      }*//*, {
        field: 'phone',
        label: '用户',
        show: false,
        detail: true,
      }*/, {
        field: 'advertiserId',  // 字段名
        label: '广告主id',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'advertiserName',  // 字段名
        label: '广告主名称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'aweMeId',  // 字段名
        label: '抖音号UID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'douYinName',  // 字段名
        label: '抖音昵称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'productId',  // 字段名
        label: '商品ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'productName',  // 字段名
        label: '商品名称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'img',  // 字段名
        label: '主图',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
        img: true
      }, {
        field: 'categoryName',  // 字段名
        label: '分类',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'grayReason',  // 字段名
        label: '不可投广的原因',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'isCreated',  // 字段名
        label: '是否已创建',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'select',
        },
        selectData: [{
          id: 1,
          name: '创建完成'
        }, {
          id: 2,
          name: '创建中'
        }, {
          id: 0,
          name: '未创建'
        }],
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              { required: true, message: 'agentId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'userId',  // 字段名
            label: 'userId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入userId',
            rules: [
              { required: true, message: 'userId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'advertiserId',  // 字段名
            label: 'advertiserId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入advertiserId',
            rules: [
              { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'aweMeId',  // 字段名
            label: 'aweMeId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入aweMeId',
            rules: [
              { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'productId',  // 字段名
            label: 'productId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入productId',
            rules: [
              { required: true, message: 'productId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'productName',  // 字段名
            label: 'productName',  // 字段显示名称
            type: 'input',
            placeholder: '请输入productName',
            rules: [
              { required: true, message: 'productName不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'img',  // 字段名
            label: 'img',  // 字段显示名称
            type: 'input',
            placeholder: '请输入img',
            rules: [
              { required: true, message: 'img不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'tag',  // 字段名
            label: 'tag',  // 字段显示名称
            type: 'input',
            placeholder: '请输入tag',
            rules: [
              { required: true, message: 'tag不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'categoryName',  // 字段名
            label: 'categoryName',  // 字段显示名称
            type: 'input',
            placeholder: '请输入categoryName',
            rules: [
              { required: true, message: 'categoryName不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'sellNum',  // 字段名
            label: 'sellNum',  // 字段显示名称
            type: 'input',
            placeholder: '请输入sellNum',
            rules: [
              { required: true, message: 'sellNum不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'grayReason',  // 字段名
            label: 'grayReason',  // 字段显示名称
            type: 'input',
            placeholder: '请输入grayReason',
            rules: [
              { required: true, message: 'grayReason不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'squareImageList',  // 字段名
            label: 'squareImageList',  // 字段显示名称
            type: 'input',
            placeholder: '请输入squareImageList',
            rules: [
              { required: true, message: 'squareImageList不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'channelId',  // 字段名
            label: 'channelId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入channelId',
            rules: [
              { required: true, message: 'channelId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'channelType',  // 字段名
            label: 'channelType',  // 字段显示名称
            type: 'input',
            placeholder: '请输入channelType',
            rules: [
              { required: true, message: 'channelType不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: [],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '更新商品',
        permission: 'launchTheProduct:updateInfo',
        click: () => {
          this.loadAdvertiserList((list) => {
            this.advertiserList = list;
            this.updateForm.advertiserId = ''
            this.visible = true
          })
        }
      },/*{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量更新',
        permission: 'launchTheProduct:updateInfo',
        click: () => {
          request.get({
            url: '/launchTheProduct/getAweMeProduct',
            success: (data) => {
              if (data.code == 0) {
                message.success("批量更新成功");
                this.$refs.table.getData()
              }
            }
          });
        }
      },*/ {
        icon: 'el-icon-info',
        type: 'warning',
        text: '新建全域推广',
        permission: 'launchTheProduct:updateInfo',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要发布的数据')
            return
          }
          this.currentDouyinList = [];
          this.loadAdvertiserList((list) => {
            this.advertiserList = list;
            this.creatTaskForm.advertiserId = ''
            this.creatTaskVisible = true
            this.creatTaskForm.aweMeId = ''
            this.creatTaskForm.productId = this.selectProductIds.join(",")
          })
          /*      request.post({
                  url: '/launchTheProduct/createTask/' + this.selectIds.join(","),
                  success: (data) => {
                    if (data.code == 0) {
                      message.success("新建全域推广成功");
                      this.$refs.table.getData()
                    } else {
                      message.error(data.msg);
                    }
                  }
                });*/
        }
      }, {
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '手动创建全域任务',
        permission: 'launchTheProduct:updateInfo',
        click: () => {
          this.loadAdvertiserList((list) => {
            this.advertiserList = list;
            this.creatForm.advertiserId = ''
            this.creatVisible = true
          })
        }
      }/*, {
        icon: 'el-icon-info',
        type: 'warning',
        text: '素材上传',
        permission: 'launchTheProduct:updateInfo',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要发布的数据')
            return
          }
          request.post({
            url: '/launchTheProduct/uploadImg/'+this.selectIds.join(","),
            success: (data) => {
              if (data.code == 0) {
                message.success("素材上传成功");
                this.$refs.table.getData()
              }
            }
          });
        }
      }*/]
    }
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll);
    // 初始化抖音账号列表为空
    this.currentDouyinList = [];
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    loadAdvertiserList(callback) {
      request.post({
        url: '/oceanEngineAdvertiser/optionsByCondition',
        data: {
          pageIndex: 1,
          pageSize: 30
        },
        success: (data) => {
          if (data.code === 0) {
            const payload = data.data || {}
            callback(Array.isArray(payload.content) ? payload.content : [])
          } else {
            message.error(data.msg || '获取账户失败');
          }
        },
        error: () => {
          message.error('获取账户失败');
        }
      });
    },
    isPageSmall(data) {
      this.pageSmall = data;
      console.log(this.pageSmall)
    },
    returnId(data) {
      this.selectIds = data;
      console.log(this.selectIds)
    },
    returnProductId(data) {
      console.log(data, 123123)
      this.selectProductIds = data;
      console.log(this.selectIds)
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitBatch(formName) {
      // console.log(this.batchForm, "123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/launchTheProduct/getAweMeProduct',
            data: this.updateForm,
            success: (res) => {
              if (res.code === 0) {
                message.success("更新全域计划成功");
                this.visible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
    submitCreatBatch(formName) {
      // console.log(this.batchForm, "123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/launchTheProduct/createTask',
            data: this.creatForm,
            success: (res) => {
              if (res.code === 0) {
                message.success("更新全域计划成功");
                this.creatVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
    submitCreatTaskBatch(formName) {
      // console.log(this.batchForm, "123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/launchTheProduct/createTask',
            data: this.creatTaskForm,
            success: (res) => {
              if (res.code === 0) {
                message.success("更新全域计划成功");
                this.creatTaskVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
    handleAdvertiserChange() {
      // 清空当前抖音账号选择
      this.updateForm.douyinId = '';
      request.get({
        url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.updateForm.advertiserId,
        success: (res) => {
          console.log(res.data, '-----------')
          if (res.code === 0) {
            this.currentDouyinList = res.data;
          } else {
            message.error(res.msg);
          }
        }
      })
    },

    handleCreatAdvertiserChange() {
      // 清空当前抖音账号选择
      this.creatForm.douyinId = '';
      request.get({
        url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.creatForm.advertiserId,
        success: (res) => {
          // console.log(res.data,'-----------')
          if (res.code === 0) {
            this.currentDouyinList = res.data;
          } else {
            message.error(res.msg);
          }
        }
      })
    },
    handleCreatTaskChange() {
      // 清空当前抖音账号选择
      this.creatTaskForm.douyinId = '';
      request.get({
        url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.creatTaskForm.advertiserId,
        success: (res) => {
          // console.log(res.data,'-----------')
          if (res.code === 0) {
            this.currentDouyinList = res.data;
          } else {
            message.error(res.msg);
          }
        }
      })
    },
  }
}
</script>

<style scoped></style>
